import CollectionPage from './collection';

export default CollectionPage;
